import { List } from 'immutable';
import {editAction} from '../../actions/editActions';
import {baseAction} from '../../actions/baseActions';

export type RootItemsReducerState = List<string>;

export function createRootItemsReducer(rootItems: List<string>) {
  return (state: RootItemsReducerState = rootItems, action: any): RootItemsReducerState => {
    switch (action.type) {
      case baseAction.ContentItems_Loaded:
        return state.concat(action.payload.rootItems) as List<string>;
      case editAction.EditAction_Reorder: {
        if (!action.payload.newParentItemId && !action.payload.oldParentItemId) {
          return state.remove(action.payload.oldPosition).insert(action.payload.newPosition, action.payload.itemId);
        }
        if (!action.payload.newParentItemId) {
          return state.insert(action.payload.newPosition, action.payload.itemId);
        }
        if (!action.payload.oldParentItemId) {
          return state.remove(action.payload.oldPosition);
        }
        return state;
      }
      case editAction.EditAction_CreateNewItem: {
        if (!action.payload.parentItemId) {
          return state.push(action.payload.item.id);
        }
        return state;
      }
      case editAction.EditAction_DeleteItem: {
        if (action.payload.parentItemId) {
          return state;
        }
        const index = state.findIndex((itemId) => itemId === action.payload.item.id);
        if (index >= 0) {
          return state.remove(index);
        }
        return state;
      }
      default:
        return state;
    }
  };
}
